import routesConfig, { RouteKey } from '@/config/routes'

export type RouteParameters = Record<string, string|number|boolean>;

function navigateToRoute(route: RouteKey, parameters?: RouteParameters) {
    setTimeout(() => {
        window.location.href = buildRouteUrl(route, parameters);
    }, 100);
}

function navigateRegisterSuccessful() {
    navigateToRoute(routesConfig.registerRedirect);
}

function navigateLoginSuccessful() {
    navigateToRoute(routesConfig.loginRedirect);
}

function navigateLogoutSuccessful() {
    navigateToRoute(routesConfig.logoutRedirect);
}

function navigateMissingAuth() {
    console.log('missing: routesConfig.missingAuth ' + routesConfig.missingAuth)
    navigateToRoute(routesConfig.missingAuth);
}

function navigateForbiddenAuth() {
    console.log('missing: routesConfig.forbiddenAuth ' + routesConfig.forbiddenAuth)
    navigateToRoute(routesConfig.forbiddenAuth);
}

function buildRouteUrl(route: RouteKey, parameters?: RouteParameters) : string {
    const url = routesConfig.routes[route].url;

    if( parameters === undefined ) {
        return url;
    }

    const queryParams = new URLSearchParams(); //Record<string, string> = {};

    let filledUrl = url;

    Object.entries(parameters).forEach(([key, value]) => {
        if( filledUrl.includes('{'+key+'}') ) {
            filledUrl = filledUrl.replaceAll('{'+key+'}', String(value));
        }
        else {
            //queryParams[key] = String(value);
            queryParams.append(key, String(value));
        }
    });

    let queryParamString = queryParams.toString();
    if( queryParamString ) {
        queryParamString = (filledUrl.includes('?') ? '&' : '?') + queryParamString;
    }

    return new URL(window.location.origin + filledUrl + queryParamString).href;
}

export default {
    navigateToRoute,
    navigateRegisterSuccessful,
    navigateLoginSuccessful,
    navigateLogoutSuccessful,
    navigateMissingAuth,
    navigateForbiddenAuth,
    buildRouteUrl,
};
